import type { Dolan, View } from '@sapappgyver/appgyver-descriptors/lib/dolan/v4';

/**
 * Helper for editing an existing view in a DOLAN by its ID.
 * @param dolan DOLAN to edit
 * @param viewId view ID to edit
 * @param edit function that takes the old view and returns the new one
 * @returns edited DOLAN
 */
export default function editViewById(dolan: Dolan, viewId: number, edit: (view: View) => View): Dolan {
  return {
    ...dolan,
    views: dolan.views.map((view) => (view.id === viewId ? edit(view) : view)),
  };
}
